export const DEFAULT_SETTINGS_TAB = "goals";

export const SETTINGS_TABS = ["goals", "documents", "team", "purchases"];

export const SETTINGS_TAB_LABELS = {
  goals: "Goals",
  documents: "Documents",
  team: "Team",
  purchases: "Past Purchases"
};

export const parseTabParam = (search) => {
  const params = new URLSearchParams(search || "");
  return params.get("tab");
};

export const isValidSettingsTab = (value) => SETTINGS_TABS.includes(value);
